// extracted by mini-css-extract-plugin
module.exports = {"container":"AsideComposite_container__jn889","aside":"AsideComposite_aside__V6laW","content":"AsideComposite_content__Hl72E"};